// Cross-product links used by the whitebot.app marketing site + hosted app.
//
// The downloadable product is a SEPARATE deployment (its own Netlify site) that
// shares the same Supabase project but NOT the browser session (different
// origin). "Entrar"/trial CTAs on the landing point here so new and downloadable
// users log in on the downloadable site; only existing hosted users use the
// hosted dashboard (reached from the Cloud beta card).
//
// When the downloadable moves to app.whitebot.app (same parent domain), update
// this single constant — cross-subdomain SSO becomes possible then too.
export const DOWNLOADABLE_APP_URL = 'https://whitebot-downloadable.netlify.app';
